import { apiInstance } from "./networking";

export const validatePan = async (payload) => {
  const { data = {} } = await apiInstance.post(`/primary/validatePAN`, payload);
  return data;
};


